module.exports = __webpack_public_path__ + "static/forecast/temperature/freeze-thaw-146a0cd3f3919c3149ea0f867fd05c71.svg";